import i18n from 'modules/core/lib/i18n'

import { FixedSalary, Salary, SalaryRange } from 'modules/job_catalog/lib/salary'

export type SalaryErrors = { [key: string]: string }

export interface ValidationContext {
  hasAllWorkplacesSalary?: boolean
}

export const validator = (
  setErrors: (errors: SalaryErrors) => void,
  context?: ValidationContext
) => {
  return (salary: Salary) => {
    let errors: SalaryErrors = {}

    if (isSalaryRange(salary)) {
      errors = { ...errors, ...validateSalaryRange(salary) }
    }
    if (isFixedSalary(salary)) {
      errors = { ...errors, ...validateFixedSalary(salary) }
    }

    // Add workplace validation
    if (context) {
      errors = { ...errors, ...validateWorkplaces(salary, context) }
    }

    setErrors(errors)
  }
}

function validateSalaryRange({ min, max }: SalaryRange): SalaryErrors {
  const errors: SalaryErrors = {}
  if (min < 0) {
    errors['minAmount'] = i18n.t('job_catalog.nodes.salary_modal.errors.positive_value')
  }
  if (max < 0) {
    errors['maxAmount'] = i18n.t('job_catalog.nodes.salary_modal.errors.positive_value')
  }
  if (max < min) {
    errors['maxAmount'] = i18n.t('job_catalog.nodes.salary_modal.errors.max_lower_than_min')
  }
  return errors
}

function validateFixedSalary({ gross }: FixedSalary) {
  const errors: SalaryErrors = {}
  if (gross < 0) {
    errors['grossSalary'] = i18n.t('job_catalog.nodes.salary_modal.errors.positive_value')
  }
  return errors
}

function isSalaryRange(salary: Salary): salary is SalaryRange {
  return salary.min !== undefined && salary.max !== undefined
}

function isFixedSalary(salary: Salary): salary is FixedSalary {
  return salary.gross !== undefined
}

function validateWorkplaces(salary: Salary, context: ValidationContext): SalaryErrors {
  const errors: SalaryErrors = {}

  // Check if workplaces are mandatory
  const isWorkplaceMandatory = context.hasAllWorkplacesSalary

  // If workplaces are mandatory, check if at least one is selected
  if (isWorkplaceMandatory && (!salary.workplaces || salary.workplaces.length === 0)) {
    errors['workplaces'] = i18n.t('job_catalog.nodes.salary_modal.errors.workplaces_required')
  }

  return errors
}
